import React from "react";
// width={data.w} height={data.h}
function Icon(data) {
  return (
     <svg
         viewBox="0 0 48 48"
         xmlns="http://www.w3.org/2000/svg"
         xmlSpace="preserve"
         style={{
           fillRule: "evenodd",
           clipRule: "evenodd",
           strokeLinejoin: "round",
           strokeMiterlimit: 2,
         }}
         width={data.w} height={data.h}
       >
         <path
           d="M21.7 35.36a.53.53 0 0 1-.39-.15.573.573 0 0 1-.16-.39.53.53 0 0 1 .16-.39.562.562 0 0 1 .78 0 .53.53 0 0 1 .16.39.573.573 0 0 1-.16.39.53.53 0 0 1-.39.15Z"
           style={{
             fill: "#dfa370",
             fillRule: "nonzero",
           }}
           transform="translate(-28.437 -31.357) scale(2.19124)"
         />
         <path
           d="m25.91 35.36-.031.001c-.28 0-.51-.23-.51-.51l.001-.031v-.02c0-.291.239-.53.53-.53h.01c.302 0 .55.248.55.55v.01c0 .291-.239.53-.53.53h-.02Z"
           style={{
             fill: "#3d3833",
             fillRule: "nonzero",
           }}
           transform="translate(-28.437 -31.357) scale(2.19124)"
         />
         <path
           d="M17.49 32.71a.999.999 0 0 1-.71-.29 1.004 1.004 0 0 1 0-1.4.999.999 0 0 1 1.41 0 1.004 1.004 0 0 1 0 1.4.999.999 0 0 1-.7.29Z"
           style={{
             fill: "#dfa370",
             fillRule: "nonzero",
           }}
           transform="translate(-28.437 -31.357) scale(2.19124)"
         />
         <path
           d="M21.7 32.71h-.004c-.549 0-1-.451-1-1 0-.549.451-1 1-1 .548 0 1 .451 1 1a1.001 1.001 0 0 1-.996 1Z"
           style={{
             fill: "#3d3833",
             fillRule: "nonzero",
           }}
           transform="translate(-28.437 -31.357) scale(2.19124)"
         />
         <path
           d="M17.49 28.5a.999.999 0 0 1-.71-.29 1.004 1.004 0 0 1 1.42-1.42c.183.19.284.446.28.71 0 .549-.451 1-1 1h.01Z"
           style={{
             fill: "#dfa370",
             fillRule: "nonzero",
           }}
           transform="translate(-28.437 -31.357) scale(2.19124)"
         />
         <path
           d="m14.39 28.05-.031.001c-.28 0-.51-.23-.51-.51l.001-.031v-.02c0-.291.239-.53.53-.53h.01c.302 0 .55.248.55.55v.01c0 .291-.239.53-.53.53h-.02ZM33.07 28.05h-.02a.532.532 0 0 1-.53-.53v-.01c0-.302.248-.55.55-.55h.01c.291 0 .53.239.53.53v.02l.001.031c0 .28-.23.51-.51.51l-.031-.001ZM30 24.44h-.004c-.549 0-1-.451-1-1 0-.549.451-1 1-1 .548 0 1 .451 1 1a1.001 1.001 0 0 1-.996 1Z"
           style={{
             fill: "#3d3833",
             fillRule: "nonzero",
           }}
           transform="translate(-28.437 -31.357) scale(2.19124)"
         />
         <path
           d="M14.39 24a.573.573 0 0 1-.39-.16c-.2-.22-.2-.56 0-.78a.573.573 0 0 1 .39-.16.53.53 0 0 1 .39.16c.21.216.21.564 0 .78a.53.53 0 0 1-.39.16ZM33.07 24a.53.53 0 0 1-.39-.16.562.562 0 0 1 0-.78.53.53 0 0 1 .39-.16.573.573 0 0 1 .39.16c.2.22.2.56 0 .78a.573.573 0 0 1-.39.16ZM25.76 20.22a.942.942 0 0 1-.7-.28 1.005 1.005 0 0 1 0-1.41 1.004 1.004 0 0 1 1.4 0 1.005 1.005 0 0 1 0 1.41.942.942 0 0 1-.7.28Z"
           style={{
             fill: "#dfa370",
             fillRule: "nonzero",
           }}
           transform="translate(-28.437 -31.357) scale(2.19124)"
         />
         <path
           d="M30 20.22a.942.942 0 0 1-.7-.28 1.005 1.005 0 0 1 0-1.41 1.004 1.004 0 0 1 1.4 0 1.005 1.005 0 0 1 0 1.41.942.942 0 0 1-.7.28Z"
           style={{
             fill: "#3d3833",
             fillRule: "nonzero",
           }}
           transform="translate(-28.437 -31.357) scale(2.19124)"
         />
         <path
           d="M21.7 16.69a.553.553 0 0 1-.548-.55c0-.302.248-.55.55-.55a.552.552 0 0 1 .388.94.53.53 0 0 1-.39.16Z"
           style={{
             fill: "#dfa370",
             fillRule: "nonzero",
           }}
           transform="translate(-28.437 -31.357) scale(2.19124)"
         />
         <path
           d="M25.76 16.69a.53.53 0 0 1-.39-.16.562.562 0 0 1 0-.78.53.53 0 0 1 .39-.16.573.573 0 0 1 .39.16c.2.22.2.56 0 .78a.573.573 0 0 1-.39.16Z"
           style={{
             fill: "#3d3833",
             fillRule: "nonzero",
           }}
           transform="translate(-28.437 -31.357) scale(2.19124)"
         />
         <path
           d="m30 28.5-1-1a.999.999 0 0 1 .29-.71 1.004 1.004 0 0 1 1.4 0 .999.999 0 0 1 0 1.41.999.999 0 0 1-.69.3ZM26.25 24.78 24.43 23a1.412 1.412 0 0 1 1.33-1h.02c.757 0 1.38.623 1.38 1.38v.03c.001.288-.082.569-.24.81-.16.251-.394.447-.67.56Z"
           style={{
             fill: "#dfa370",
             fillRule: "nonzero",
           }}
           transform="translate(-28.437 -31.357) scale(2.19124)"
         />
         <path
           d="m21.7 20.22-1-1a.999.999 0 0 1 .29-.71 1.004 1.004 0 0 1 1.4 0 1.005 1.005 0 0 1 0 1.41.94.94 0 0 1-.69.3ZM17.49 24.44a.999.999 0 0 1-.71-.29 1.004 1.004 0 0 1 0-1.4.999.999 0 0 1 1.41 0 1.004 1.004 0 0 1 0 1.4.999.999 0 0 1-.7.29ZM21.7 28.91h-.03c-.752 0-1.37-.618-1.37-1.37v-.03a1.33 1.33 0 0 1 .4-1 1.426 1.426 0 0 1 2 0c.268.262.414.625.4 1v.03c0 .752-.618 1.37-1.37 1.37h-.03Z"
           style={{
             fill: "#3d3833",
             fillRule: "nonzero",
           }}
           transform="translate(-28.437 -31.357) scale(2.19124)"
         />
         <path
           d="M25.76 32.71a.999.999 0 0 1-.7-.29 1.004 1.004 0 0 1 0-1.4 1 1 0 1 1 .724 1.69h-.024Z"
           style={{
             fill: "#dfa370",
             fillRule: "nonzero",
           }}
           transform="translate(-28.437 -31.357) scale(2.19124)"
         />
         <path
           d="M33.67 35.64a.63.63 0 0 1-.44-.19L13.72 15.94a.632.632 0 0 1 .89-.89l19.51 19.5c.118.12.185.282.185.45a.643.643 0 0 1-.635.64Z"
           style={{
             fill: "#3d3833",
             fillRule: "nonzero",
           }}
           transform="translate(-28.437 -31.357) scale(2.19124)"
         />
       </svg>

  );
}

export default Icon;
